import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Radio } from "@mui/material";

const performanceOptions = [
  { value: "4", label: "Lo demostró en un nivel excepcional" },
  { value: "3", label: "Lo demostró consistentemente" },
  { value: "2", label: "Lo demostró de manera ocasional" },
  { value: "1", label: "No lo demostró" },
];

export default function ValuesSection({ values, setValues, valuesErrors, setValuesErrors }) {
  const handleRatingChange = (index, value) => {
    const updatedValues = [...values];
    updatedValues[index].rating = value;
    setValues(updatedValues);

    if (valuesErrors.includes(index)) {
      const updatedErrors = valuesErrors.filter((i) => i !== index);
      setValuesErrors(updatedErrors);
    }
  };

  return (
    <Box mb={4}>
      <Typography variant="h6" gutterBottom>
        Evaluación de Valores
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Valor</TableCell>
              {performanceOptions.map((option) => (
                <TableCell
                  key={option.value}
                  align="center"
                  sx={{ fontWeight: "bold", fontSize: "0.85rem" }}
                >
                  {option.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {values.map((val, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor: valuesErrors.includes(index) ? "#ffebee" : "inherit",
                }}
              >
                <TableCell sx={{ fontSize: "0.9rem", verticalAlign: "top" }}>
                  <Box>
                    <Typography sx={{ fontWeight: "bold" }}>{val.key}</Typography>
                    <Typography variant="body2">{val.description}</Typography>
                    {valuesErrors.includes(index) && (
                      <Typography
                        variant="caption"
                        sx={{ color: "error.main", display: "block", mt: 0.5 }}
                      >
                        Falta evaluar este valor.
                      </Typography>
                    )}
                  </Box>
                </TableCell>
                {performanceOptions.map((option) => (
                  <TableCell key={option.value} align="center">
                    <Radio
                      checked={val.rating === option.value}
                      onChange={() => handleRatingChange(index, option.value)}
                      value={option.value}
                      size="small"
                    />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
